import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { AbbIconComponent } from '@components/abb-icon/abb-icon.component';
import { Status } from 'gql/graphql';

@Component({
  selector: 'abb-status-icon',
  standalone: true,
  imports: [AbbIconComponent, CommonModule],
  template: `
    @switch (status()) { @case (Status.Ok) {
    <abb-icon
      [size]="size()"
      [name]="okIcon()"
      class="cursor-default text-abb-success"
    />
    } @case (Status.Warning) {
    <abb-icon
      [size]="size()"
      [name]="warningIcon()"
      class="cursor-default text-abb-warning"
    />
    }@case (Status.Alarm) {
    <abb-icon
      [size]="size()"
      [name]="alarmIcon()"
      class="cursor-default text-abb-error"
    />
    }}
  `,
  styles: ``,
})
export class AbbStatusIconComponent {
  status = input.required<Status>();
  size = input<'small' | 'medium' | 'large'>('medium');
  variant = input<'filled' | 'outlined'>('filled');
  readonly Status = Status;
  okIcon = computed(() =>
    this.variant() === 'filled'
      ? 'abb/check-mark-circle-1'
      : 'mat-outlined/check_circle'
  );
  warningIcon = computed(() =>
    this.variant() === 'filled'
      ? 'abb/warning-triangle'
      : 'mat-outlined/warning_amber'
  );
  alarmIcon = computed(() =>
    this.variant() === 'filled'
      ? 'abb/warning-circle-1'
      : 'mat-outlined/error_outline'
  );
}
